import React, {Component} from 'react'
import PropTypes from 'prop-types'
import theme from '../../theme'
import {apiAddress} from '../../../services/api';

// Material components
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import SidebarItem from "../Sidebar/SidebarItem/SidebarItem";
import Information from '../../components/Information/Information'
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import {t} from 'i18next'
import {Trans} from 'react-i18next'






/**
 * component for sidebar
 * @param classes
 * @returns {*}
 */
class ApiAccessManagement extends Component {

    constructor(props) {
        super(props);

        this.state = {
            confirmText: '',
            errorMsg: ''
        }
    }

    onClaimToken = () => {
        

       
            this.props.onTokenRequest(
                (accessToken) => {
                    this.props.onSuccess(accessToken);
                },
                (error) => {
                    if(error.msg) {
                        this.setState({errorMsg: error.msg})
                    }
                });
        
    };

     copyToClipboard = (content) => {
        const el = document.createElement('textarea');
        el.value = content;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      };

    render() {
        return (
            
            <div>
            {!this.props.tokenIssued &&
            <SidebarItem
            title={t('User.title_api_access')}
            subtitle={t('User.subtitle_api_access')}
            divider>
                
                    <Button style={{color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20, padding: 0 }}
                     onClick={()=> window.open(`${apiAddress}`, "_blank")}
                            > 
                          <Trans i18nKey='Global.button_open'></Trans>
                    </Button>
                
                
            </SidebarItem>
             }
                <SidebarItem style={{marginTop:20}}
                    title={this.props.tokenIssued ? "" : t('User.title_token')}
                    subtitle={this.props.tokenIssued ? "" : t('User.subtitle_token')}
                    divider={this.props.tokenIssued}
                >
                    <TextField
                        label={this.props.tokenIssued ?  t('User.textfield_label_token') : ""}
                        fullWidth={true}
                        variant={'standard'}
                        value={this.props.tokenData ? this.props.tokenData : t('User.textfield_label_token')}
                        style={this.props.tokenIssued?
                        {
                            display: 'flex',
                            flexDirection: 'row',
                            borderRadius: 4,
                            border: '1px solid #ced4da',                        
                        }
                        :
                        {
                            display: 'flex',
                            flexDirection: 'row',
                        }
                        }     
                        InputProps={ this.props.tokenIssued ? {
                            disableUnderline: true,
                            readOnly: true,
                            
                            endAdornment: (
                               
                                <InputAdornment position="end">
                                    <IconButton
                                    style={{marginBottom: 15}}
                                        onClick={() => {                                          
                                            this.copyToClipboard(this.props.tokenData)                                            
                                         }}
                                    ><FileCopyIcon /></IconButton>
                                </InputAdornment>
                                
                            ) 
                        } : 
                        {
                          
                            disableUnderline: true,
                            readOnly: true,
                           
                        }}

                    >
                    </TextField>
                    {!this.props.tokenIssued &&
                    <Button style={this.props.tokenData? { marginTop: 20, padding: 0, marginRight: 20 }:{color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20, padding: 0, marginRight: 20 }}
                            disabled={this.props.tokenData? true:false}
                            onClick={this.props.requestToken}
                    ><Trans i18nKey='User.button_create'></Trans>
                            </Button>
                    }
                    {!this.props.tokenIssued &&
                    <Button style={this.props.tokenData? {color: theme.palette.primary.dark, borderColor: theme.palette.primary.dark, marginTop: 20, padding: 0 }: { marginTop: 20, padding: 0, marginRight: 20 }}
                            disabled={this.props.tokenData? false:true}
                            onClick={this.props.revokeToken}
                    ><Trans i18nKey='User.button_revert'></Trans>
                            </Button>
                    }
                
            </SidebarItem>
            {this.props.tokenIssued &&
                <SidebarItem
                 title={t('User.title_token_information')}
                 
                >
                     <Information>
                    <Trans i18nKey='User.text_token_information'></Trans>
                    </Information>
                </SidebarItem>
            }
            </div>
       
        )
    }
}

const styles = {
    textStyle: {
        fontWeight: 600,
        lineHeight: 2,
        color: theme.palette.error.dark,
    },
    inputContainer: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        display: 'flex',
        flex: 1
    },
    textFieldFormLabel: {
        '&$textFieldFocused': {
            color: theme.palette.primary.dark,
        },
    },
    textFieldFocused: {},
    textFieldUnerline: {
        '&:after': {
            borderBottomColor: theme.palette.primary.dark,
        },
    },
};

ApiAccessManagement.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    // onRequestToken: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    revokeToken: PropTypes.func.isRequired,
    requestToken: PropTypes.func.isRequired
}

export default ApiAccessManagement
